export default __webpack_public_path__ + "media/images/39-bd0d6ca3c55436f840e09e3cd8e3ab37.jpg";